import React from 'react'
import { Skeleton, csx } from '@vtex/admin-ui'
import { ProductCarouselItem } from '@/checkout-instore-legacy/components/ProductCarousel'

export const SkeletonItem = () => (
  <ProductCarouselItem>
    <Skeleton
      className={csx({
        display: 'block',
        height: 'auto',
        paddingBottom: '100%',
      })}
    />
    <Skeleton
      className={csx({
        display: 'block',
        width: '100px',
        height: '20px',
        marginTop: '$space-3',
        '@desktop': {
          marginTop: '$space-4',
          height: '24px',
        },
      })}
    />
    <Skeleton
      className={csx({
        display: 'block',
        width: '80px',
        height: '16px',
        marginTop: '$space-1',
      })}
    />
  </ProductCarouselItem>
)
